import { render, staticRenderFns } from "./FormBuyingInterest.vue?vue&type=template&id=64c3817a&scoped=true&"
import script from "./FormBuyingInterest.vue?vue&type=script&lang=js&"
export * from "./FormBuyingInterest.vue?vue&type=script&lang=js&"
import style0 from "./FormBuyingInterest.vue?vue&type=style&index=0&id=64c3817a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c3817a",
  null
  
)

export default component.exports